import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/tablet/6_turquoise/6_turquoise"
 * Contains 1 texture(s)
 */
export class Tablet6TurquoiseAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/tablet/6_turquoise/6_turquoise';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '6_turquoise.png'
    ] as const;
}
